<template lang="pug">
  nav.admin_global_navigation#js_admin_global_navigation(
    :aria-hidden="isHamburgerOpend === true ? 'true' : 'false'")
    .admin_global_navigation_top
      .admin_global_navigation_user
        .admin_global_navigation_avatar
          img(:src="userPhotoUrl")
        .admin_global_navigation_name {{ userName }}
    ul.admin_global_navigation_list
      li.admin_global_navigation_item
        router-link(to="/article" active-class="active" @click.native="closeGlobalNavigation()")
          b-icon(icon="file-alt")
          span.admin_global_navigation_heading 記事
      li.admin_global_navigation_item
        router-link(to="/media" active-class="active" @click.native="closeGlobalNavigation()")
          b-icon(icon="image-v")
          span.admin_global_navigation_heading メディア
      li.admin_global_navigation_item
        router-link(to="/category" active-class="active" @click.native="closeGlobalNavigation()")
          b-icon(icon="folder")
          span.admin_global_navigation_heading カテゴリ
      li.admin_global_navigation_item
        router-link(to="/tag" active-class="active" @click.native="closeGlobalNavigation()")
          b-icon(icon="tag-alt")
          span.admin_global_navigation_heading タグ
      li.admin_global_navigation_item(v-if="userRole == 1")
        router-link(to="/user" active-class="active" @click.native="closeGlobalNavigation()")
          b-icon(icon="users-alt")
          span.admin_global_navigation_heading ユーザー
</template>

<script>

export default {
  name: 'global-navigation',
  data: function(){
    return {
      userName: this.$cookies.get('user_name'),
      userPhotoUrl: this.$cookies.get('user_photo_url'),

      userRole: this.$cookies.get('role')
    }
  },
  props: [
    'isHamburgerOpend'
  ],
  methods: {
    switchGlobalNavigation() {
      this.$emit('switchNavigation')
    },
    closeGlobalNavigation() {
      this.$emit('closeNavigation')
    },
  }
}
</script>